import React, { useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Row,
  Col,
  // Upload,
  Radio,
  Checkbox,
  Card,
  message,
  Typography,
  Spin,
} from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
  RetweetOutlined,
  FormOutlined,
  BackwardOutlined,
  // UploadOutlined,
} from "@ant-design/icons";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import axiosInstance from "../../../api/Axios";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  CourseTopLevel,
  CourseTopLevelCA,
} from "../../../components/AdminComponents/MenuItems";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import MediaUpload from "./MediaUpload";
const { Option } = Select;
const { Title, Paragraph } = Typography;
const CourseQuizAdd = () => {
  const { id } = useParams();
  const userInfo = useSelector((state) => state.user);
  const [form] = Form.useForm();
  const [isViewMode, setIsViewMode] = useState(!!id);
  const [courses, setCourses] = useState([]);
  const [questions, setQuestions] = useState([
    {
      id: 1,
      order_index: 1,
      type: null,
      options: [
        { id: 1, text: "Option 1", isCorrect: false, order_index: 1 },
        { id: 2, text: "Option 2", isCorrect: false, order_index: 2 },
      ],
      media: null,
    },
  ]);
  const [activeEdit, setActiveEdit] = useState(null);
  const [invalidQuestionIds, setInvalidQuestionIds] = useState([]);
  const [coursesLoading, setCoursesLoading] = useState(false);

  const isEditing = (type, id, parentId = null) => {
    if (!activeEdit) return false;
    if (activeEdit.type !== type) return false;
    if (activeEdit.id !== id) return false;
    if (parentId && activeEdit.parentId !== parentId) return false;
    return true;
  };

  const canShowEdit = (type, id, parentId = null) => {
    if (!isViewMode) return false;
    if (!activeEdit) return true;
    return isEditing(type, id, parentId);
  };

  //This is for Course Listing in quiz edit page

  const fetchCourses = useCallback(async () => {
    setCoursesLoading(true);
    try {
      const resp = await axiosInstance.get(`/learn/quiz/courses/?organization_id=${userInfo?.data?.organization?.id}`);
      // Map list API (course_id, course_display_id, course_name) to unified format
      const unifiedCourses = (resp.data || []).map(c => ({
        id: c.course_id,
        display_id: c.course_display_id,
        name: c.course_name
      }));
      setCourses(unifiedCourses);
    } catch (err) {
      console.error("Error fetching courses:", err);
    } finally {
      setCoursesLoading(false);
    }
  }, [userInfo]);

  const fetchQuizData = useCallback(async () => {
    try {
      const response = await axiosInstance.get(`/learn/quiz/${id}/`);
      const quizData = response.data;

      // Map API data to form fields
      // Map API data to form fields from the "courses" array
      const courseId = quizData.courses?.[0]?.id || quizData.course_id;
      const courseDisplayId = quizData.courses?.[0]?.course_id || quizData.course_display_id;
      form.setFieldsValue({
        quizTitle: quizData.quiz_name,
        quizDesc: quizData.description,
        passing_score: quizData.passing_score,
        timeLimit: quizData.time_limit_minutes,
        course: courseId,
        courseDisplayId: courseDisplayId,
      });

      // Map questions if they exist in the response
      if (quizData.questions && quizData.questions.length > 0) {
        setQuestions(quizData.questions.map((q, index) => {
          const qId = q.question_id || q.id || index + 1;
          // Forcing 4 options as per requirement. Old fallback was ["Option 1", "Option 2"]
          const mappedOptions = (q.answers || q.options || ["Option 1", "Option 2", "Option 3", "Option 4"]).map((a, i) => {
            if (typeof a === "string") return { id: i + 1, text: a, isCorrect: false, order_index: i + 1 };
            return {
              id: a.answer_id || a.id || i + 1,
              text: a.answer_text || a.text || "",
              is_correct: a.is_correct || a.isCorrect || false,
              isCorrect: a.is_correct || a.isCorrect || false,
              order_index: a.order_index || i + 1,
            };
          }).sort((a, b) => (a.order_index || 0) - (b.order_index || 0));

          return {
            id: qId,
            order_index: q.order_index || index + 1,
            type: q.answer_type || q.type || null,
            options: mappedOptions,
            media: q.media || null,
            text: q.question_text || ""
          };
        }));

        // Populate question text and option fields in the form
        const questionFields = {};
        quizData.questions.forEach((q, index) => {
          const qId = q.question_id || q.id || index + 1;
          questionFields[`question_${qId}`] = q.question_text || q.text;

          (q.answers || q.options || []).forEach((a, i) => {
            const aId = a.answer_id || a.id || i + 1;
            const aText = a.answer_text || a.text || (typeof a === "string" ? a : "");
            questionFields[`question_${qId}_opt_${aId}`] = aText;
            questionFields[`question_${qId}_correct_${aId}`] = a.is_correct || a.isCorrect || false;
          });
          questionFields[`question_${qId}_points`] = q.points || 0;
          questionFields[`question_${qId}_feedback_tip`] = q.feedback_tip || "";
          questionFields[`question_${qId}_type`] = q.answer_type || q.type || null;
        });
        form.setFieldsValue(questionFields);
      }

      // Populate courses state with the single assigned course from quiz data
      // This ensures the name is visible in View mode without calling courselist API
      if (quizData.courses && quizData.courses.length > 0) {
        // Map detail API (id, course_id, name) to unified format
        const unifiedCurrentCourses = quizData.courses.map(c => ({
          id: c.id,
          display_id: c.course_id,
          name: c.name
        }));
        setCourses(unifiedCurrentCourses);
      } else if (courseId) {
        setCourses([{
          id: courseId,
          display_id: courseDisplayId,
          name: quizData.course_name || "Assigned Course"
        }]);
      }
    } catch (error) {
      console.error("Error fetching quiz data:", error);
      message.error("Failed to fetch quiz details");
    }
  }, [id, form]);

  useEffect(() => {
    if (id) {
      fetchQuizData();
    }
  }, [id, fetchQuizData]);

  // Only fetch full course list when in creation mode or when user clicks 'Edit Quiz'
  useEffect(() => {
    if (!isViewMode && courses.length <= 1) {
      fetchCourses();
    }
  }, [isViewMode, fetchCourses, courses.length]);

  // Add new question
  const addQuestion = () => {
    const newId = Date.now();
    setQuestions(prev => {
      const nextOrder = prev.length > 0 ? Math.max(...prev.map(q => q.order_index || 0)) + 1 : 1;
      return [
        ...prev,
        {
          id: newId,
          order_index: nextOrder,
          type: null,
          options: [
            { id: Date.now() + 1, text: "Option 1", isCorrect: false, order_index: 1 },
            { id: Date.now() + 2, text: "Option 2", isCorrect: false, order_index: 2 },
          ],
          media: null,
        },
      ];
    });

    // Sync with form
    form.setFieldValue(`question_${newId}_type`, null);

    // Automatically trigger edit mode for the brand new question only if we have a quiz ID (View mode specifically)
    if (id && isViewMode) {
      setActiveEdit({ type: 'question', id: newId });
    }
  };




  // Add option to a question
  const addOption = (qIndex) => {
    if (id) return; // Only in creation mode
    const q = questions[qIndex];
    const maxOptions = q.type === "multiple" ? 6 : 4;

    if (q.options.length >= maxOptions) {
      message.warning(`Maximum ${maxOptions} options allowed for ${q.type || 'this'} question type.`);
      return;
    }

    const newOptId = Date.now();
    const newQs = [...questions];
    const nextOrder = newQs[qIndex].options.length > 0
      ? Math.max(...newQs[qIndex].options.map(opt => opt.order_index || 0)) + 1
      : 1;

    newQs[qIndex].options.push({
      id: newOptId,
      text: "",
      isCorrect: false,
      order_index: nextOrder
    });
    setQuestions(newQs);
  };

  // Remove option
  const removeOption = (qIndex, optIndex) => {
    if (id) return; // Only in creation mode
    const q = questions[qIndex];
    const minOptions = q.type === "multiple" ? 3 : 2;

    if (q.options.length <= minOptions) {
      message.warning(`Minimum ${minOptions} options required for ${q.type || 'this'} question type.`);
      return;
    }

    const newQs = [...questions];
    newQs[qIndex].options.splice(optIndex, 1);
    setQuestions(newQs);
  };

  // eslint-disable-next-line no-unused-vars
  const handleUpload = (qIndex, file) => {
    const newQs = [...questions];
    newQs[qIndex].media = URL.createObjectURL(file);
    setQuestions(newQs);
    return false; // prevent auto upload
  };

  // eslint-disable-next-line no-unused-vars
  const onFinish = (values) => {
    console.log("Final Quiz Data Handled");
  };
  const location = useLocation();
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CourseTopLevelCA : CourseTopLevel;
  const [fileList, setFileList] = useState([]);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadPercent, setUploadPercent] = useState(0);

  const handleChange = (info) => {
    const file = info.file.originFileObj;
    if (file) {
      setUploading(true);
      setUploadPercent(0);
      setFileList([file]);
      setPreviewUrl(URL.createObjectURL(file));

      // simulate upload progress
      const interval = setInterval(() => {
        setUploadPercent((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            setUploading(false);
            return 100;
          }
          return prev + 10;
        });
      }, 100);
    }
  };

  const handleClear = (e) => {
    e.stopPropagation();
    setFileList([]);
    setPreviewUrl(null);
    setUploadPercent(0);
  };

  const modifyFileName = (name) => {
    return name.replace(/_\d+(?=\.)/, "");
  };
  const getCookie = (name) => {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  };

  const handleSaveQuestion = async (qId) => {
    try {
      const qIndex = questions.findIndex(q => q.id === qId);
      const q = questions[qIndex];
      const values = form.getFieldsValue();
      const isNew = typeof q.id !== "string";

      // Map current answer values from form and state
      const mappedAnswers = q.options.map((opt) => {
        const oId = opt.id || opt.answer_id;
        return {
          answer_id: typeof oId === 'string' ? oId : undefined,
          answer_text: form.getFieldValue(`question_${q.id}_opt_${oId}`) || opt.text || opt.answer_text,
          is_correct: form.getFieldValue(`question_${q.id}_correct_${oId}`) ?? !!(opt.is_correct || opt.isCorrect),
          order_index: opt.order_index, // Preserve the original database mapping
        };
      });

      // Validation for correct answers count
      if (!q.type) {
        setInvalidQuestionIds(prev => [...new Set([...prev, q.id])]);
        message.error(`Question ${q.order_index}. : Question Type is not selected`);
        return;
      }

      const correctCount = mappedAnswers.filter(a => a.is_correct).length;
      if (q.type === "single" && correctCount !== 1) {
        setInvalidQuestionIds(prev => [...new Set([...prev, q.id])]);
        message.error(`Question ${q.order_index}. : Select atleast 1 option`);
        return;
      }
      if (q.type === "multiple" && correctCount < 2) {
        setInvalidQuestionIds(prev => [...new Set([...prev, q.id])]);
        message.error(`Question ${q.order_index}. : Select atleast 2 or more option`);
        return;
      }

      // Clear invalid state if validation passes
      setInvalidQuestionIds(prev => prev.filter(id => id !== q.id));

      const payload = {
        question_text: form.getFieldValue(`question_${q.id}`),
        answer_type: q.type,
        points: form.getFieldValue(`question_${q.id}_points`),
        feedback_tip: form.getFieldValue(`question_${q.id}_feedback_tip`),
        order_index: q.order_index,
        organization_id: userInfo?.data?.organization?.id,
        answers: mappedAnswers,
      };

      const csrfToken = getCookie("csrftoken");
      const headers = { "X-CSRFToken": csrfToken };

      if (!isNew) {
        // Update Existing Question
        await axiosInstance.put(`/learn/quiz/questions/${q.id}/`, payload, { headers });
        message.success("Question updated successfully!");
      } else {
        // Create New Question
        await axiosInstance.post(`/learn/quiz/${id}/questions/`, payload, { headers });
        message.success("Question created successfully!");
      }
      await fetchQuizData();
      setActiveEdit(null);
    } catch (error) {
      console.error("Error saving question:", error);
      message.error("Failed to save question");
    }
  };

  const handleSaveAnswer = async (qId, optId) => {
    try {
      const qIndex = questions.findIndex(q => q.id === qId);
      const q = questions[qIndex];
      const optIndex = q.options.findIndex(o => o.id === optId);
      const opt = q.options[optIndex];
      const values = form.getFieldsValue();

      const payload = {
        answer_text: values[`question_${q.id}_opt_${opt.id}`] || "",
        is_correct: !!values[`question_${q.id}_correct_${opt.id}`],
        order_index: opt.order_index, // Preserve database order_index
        organization_id: userInfo?.data?.organization?.id,
      };

      const csrfToken = getCookie("csrftoken");
      const headers = { "X-CSRFToken": csrfToken };

      if (typeof opt.id === "string") {
        // Update Existing Answer
        await axiosInstance.put(`/learn/quiz/answers/${opt.id}/`, payload, { headers });
        message.success("Answer updated successfully!");
      } else {
        // Create New Answer
        const response = await axiosInstance.post(`/learn/quiz/questions/${q.id}/answers/`, payload, { headers });
        message.success("Answer created successfully!");
      }
      await fetchQuizData();
      setActiveEdit(null);
    } catch (error) {
      console.error("Error saving answer:", error);
      message.error("Failed to save answer");
    }
  };

  const navigate = useNavigate();
  const handleSubmit = async (values) => {
    try {
      // Validate correct answers count for all questions before proceeding
      const newInvalidIds = [];
      for (const q of questions) {
        if (!q.type) {
          newInvalidIds.push(q.id);
          message.error(`Question ${q.order_index}. : Question Type is not selected`);
          continue;
        }

        const correctCount = q.options.reduce((acc, opt) => {
          const isCorrect = !!values[`question_${q.id}_correct_${opt.id}`];
          return isCorrect ? acc + 1 : acc;
        }, 0);

        if (q.type === "single" && correctCount !== 1) {
          newInvalidIds.push(q.id);
          message.error(`Question ${q.order_index}. : Select atleast 1 option`);
        } else if (q.type === "multiple" && correctCount < 2) {
          newInvalidIds.push(q.id);
          message.error(`Question ${q.order_index}. : Select atleast 2 or more option`);
        }
      }

      setInvalidQuestionIds(newInvalidIds);

      if (newInvalidIds.length > 0) {
        return;
      }

      const payload = {
        quiz_name: values.quizTitle,
        description: values.quizDesc,
        passing_score: parseFloat(values.passing_score || 0).toFixed(2),
        time_limit_minutes: parseInt(values.timeLimit || 0),
        status: true,
        organization_id: userInfo?.data?.organization?.id,
        questions: questions.map((q, qIndex) => {
          const mappedAnswers = q.options.map((opt, optIndex) => {
            const answerPayload = {
              is_correct: !!values[`question_${q.id}_correct_${opt.id}`],
              answer_text: values[`question_${q.id}_opt_${opt.id}`] || "",
              order_index: opt.order_index || optIndex + 1,
              organization_id: userInfo?.data?.organization?.id,
            };
            // Preserve answer UUID if it exists
            if (typeof opt.id === "string") {
              answerPayload.answer_id = opt.id;
            }
            return answerPayload;
          });

          const questionPayload = {
            question_text: values[`question_${q.id}`],
            answer_type: q.type,
            points: parseInt(values[`question_${q.id}_points`] || 0),
            order_index: q.order_index || qIndex + 1,
            feedback_tip: values[`question_${q.id}_feedback_tip`] || "",
            organization_id: userInfo?.data?.organization?.id,
            answers: mappedAnswers,
          };

          // Preserve question UUID if it exists
          if (typeof q.id === "string") {
            questionPayload.question_id = q.id;
          }

          return questionPayload;
        }),
      };

      const csrfToken = getCookie("csrftoken");
      const headers = {
        "X-CSRFToken": csrfToken,
        //"x-csrftoken": csrfToken,
      };

      if (id) {
        // For Update, send the course_id directly
        payload.course_id = values.course;

        await axiosInstance.put(`/learn/quiz/${id}/`, payload, { headers });
        message.success("Quiz updated successfully!");
        await fetchQuizData();
        setIsViewMode(true);
      } else {
        // For Create, send course_id as a string
        payload.course_id = String(values.course);
        await axiosInstance.post("/learn/quizcreate/", payload, { headers });
        message.success("Quiz created successfully!");
        navigate(isCAAdmin ? "/ca-admin/trainery-learn/quiz" : "/trainery-learn/quiz/listing");
      }
    } catch (error) {
      console.error("Error saving quiz:", error);
      message.error("Failed to save quiz");
    }
  };

  const onFinishFailed = (errorInfo) => {
    const quizDetailFields = ["course", "quizTitle", "passing_score"];
    let quizDetailsMissing = false;
    const missingQuestionIndices = new Set();

    errorInfo.errorFields.forEach((field) => {
      const fieldName = String(field.name[0]);
      if (quizDetailFields.includes(fieldName)) {
        quizDetailsMissing = true;
      } else if (fieldName.startsWith("question_")) {
        // Handle fields like 'question_ID' or 'question_ID_opt_ID'
        const parts = fieldName.split("_");
        const qId = parts[1];
        const question = questions.find((q) => String(q.id) === qId);
        if (question) {
          missingQuestionIndices.add(question.order_index);
        }
      }
    });

    if (quizDetailsMissing) {
      message.error("Quiz Details are missing");
    }

    if (missingQuestionIndices.size > 0) {
      const sortedIndices = Array.from(missingQuestionIndices).sort((a, b) => a - b);
      sortedIndices.forEach((index) => {
        message.error(`Question ${index} details are missing`);
      });
    }
  };
  return (
    <WrapperComponent props={wrapperProps}>
      <div
        style={{
          marginTop: "50px",
          paddingTop: "30px",
        }}
      >
        <Card
          className="shadow-lg rounded-2xl"
          style={{
            width: "95%",
            margin: "10px auto",
            borderRadius: "12px",
            background: "#fbfbfb",
          }}
        >
          <div
            style={{
              paddingLeft: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              paddingRight: "20px",
            }}
          >
            <div>
              <Title level={4} style={{ letterSpacing: "0.5px", marginBottom: "4px" }}>
                {id ? (isViewMode ? "Quiz View" : "Quiz Edit") : "Quiz Creation"}
              </Title>
              <Paragraph type="secondary" style={{ marginBottom: "0px" }}>
                {id
                  ? isViewMode
                    ? "View the quiz details and configurations below"
                    : "Update and configure your quiz details below"
                  : "Add and configure your own quiz with the details below"}
              </Paragraph>
            </div>
            {id && (
              isViewMode ? (
                <Button
                  type="primary"
                  icon={<FormOutlined />}
                  onClick={() => setIsViewMode(false)}
                  className="save-update-btn"
                  disabled={activeEdit !== null}
                >
                  Edit Quiz
                </Button>
              ) : (
                <div style={{ display: "flex", gap: "8px" }}>
                  <Button
                    onClick={async () => {
                      await fetchQuizData();
                      setIsViewMode(true);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              )
            )}
          </div>

          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            onFinishFailed={onFinishFailed}
            style={{ padding: "20px" }}
            initialValues={{ questionType: "single" }}
          >
            {/* Course & Quiz Details */}
            {/* Row 1: Course Info */}
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="courseDisplayId"
                  label="Course ID"
                >
                  <Input
                    readOnly
                    style={{ backgroundColor: "#ffffffff", cursor: "not-allowed" }}
                    placeholder={!form.getFieldValue("course") ? "Auto-populated" : ""}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="course"
                  label="Course Name"
                  rules={[
                    { required: true, message: "Please select a course" },
                  ]}
                >
                  <Select
                    placeholder="Select course"
                    showSearch
                    optionFilterProp="children"
                    optionLabelProp="label"
                    loading={coursesLoading}
                    notFoundContent={coursesLoading ? <div style={{ textAlign: 'center', padding: '10px' }}><Spin size="small" /></div> : "No Data Found"}
                    disabled={isViewMode}
                    onChange={(val) => {
                      const selectedCourse = courses.find((c) => c.id === val);
                      form.setFieldsValue({
                        courseDisplayId: selectedCourse?.display_id,
                      });
                    }}
                  >
                    {courses.map((c) => (
                      <Option key={c.id} value={c.id} label={c.name}>
                        <span style={{ fontWeight: "bold" }}>{c.name}</span> -{" "}
                        <span style={{ color: "gray", fontSize: "12px" }}>{c.display_id}</span>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            {/* Row 2: Quiz Info */}
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="quizTitle"
                  label="Quiz Name"
                  rules={[
                    { required: true, message: "Please enter quiz title" },
                  ]}
                >
                  <Input placeholder="Enter quiz title" disabled={isViewMode} />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="passing_score"
                  label="Passing Score (%)"
                  rules={[{ required: false, message: "Please enter passing score" }]}
                >
                  <Input type="number" placeholder="e.g. 80" disabled={isViewMode} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  name="timeLimit"
                  label="Enter time Limit (minutes)"
                  rules={[
                    { required: false, message: "Please enter time limit" },
                  ]}
                >
                  <Input type="number" placeholder="Enter time limit" disabled={isViewMode} />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="quizDesc" label="Quiz Description">
                  <Input.TextArea rows={3} placeholder="Enter description" disabled={isViewMode} />
                </Form.Item>
              </Col>
            </Row>

            {/* Dynamic Questions */}
            {questions.map((q, qIndex) => (
              <Card
                key={q.id}
                type="inner"
                title={
                  <div
                    style={{
                      // backgroundColor: "#fff", // light blue
                      padding: "4px 12px",
                      borderRadius: "8px",
                      width: "100%", // full width
                      boxSizing: "border-box", // include padding in width
                    }}
                  >
                    {`Question ${q.order_index}`}
                  </div>
                }
                headStyle={{
                  backgroundColor: "aliceblue",
                  // color: "white",
                  padding: "4px 12px",
                }}
                style={{
                  marginTop: "20px",
                  borderRadius: "12px",
                  border: invalidQuestionIds.includes(q.id) ? "2px solid #ff4d4f" : "1px solid #f0f0f0"
                }}
                hoverable
                extra={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      paddingRight: "8px"
                    }}
                  >
                    <div style={{ display: "flex", gap: "8px" }}>
                      {id && isEditing('question', q.id) ? (
                        <>
                          {id && (
                            <Button
                              type="primary"
                              size="small"
                              onClick={() => handleSaveQuestion(q.id)}
                              className="save-update-btn"
                            >
                              Save
                            </Button>
                          )}
                          <Button size="small" onClick={async () => {
                            const isNew = typeof q.id === 'number';
                            if (isNew) {
                              setQuestions(questions.filter(item => item.id !== q.id));
                              setActiveEdit(null);
                            } else {
                              await fetchQuizData();
                              setActiveEdit(null);
                            }
                          }}>X</Button>
                        </>
                      ) : (
                        canShowEdit() && (
                          <Button
                            type="link"
                            icon={<FormOutlined />}
                            onClick={() => setActiveEdit({ type: 'question', id: q.id })}
                          >
                            Edit
                          </Button>
                        )
                      )}
                      {!isViewMode && questions.length > 1 && !activeEdit && (
                        <Button
                          danger
                          size="small"
                          onClick={() => setQuestions(questions.filter((_, i) => i !== qIndex))}
                        >
                          <DeleteOutlined />
                        </Button>
                      )}
                    </div>
                  </div>
                }
              >
                <Row gutter={16}>
                  <Col span={16}>
                    <Form.Item
                      name={`question_${q.id}`}
                      label="Question Text"
                      rules={[
                        {
                          required: true,
                          message: "Please enter the question",
                        },
                      ]}
                    >
                      <ReactQuill
                        theme="snow"
                        placeholder="Type your question here..."
                        readOnly={isViewMode && !isEditing('question', q.id)}
                        style={{
                          height: "150px",
                          marginBottom: "40px",
                          fontFamily: "Poppins",
                        }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      name={`question_${q.id}_points`}
                      label="Points allocated"
                      rules={[
                        {
                          required: false,
                          message: "Please enter the points",
                        },
                      ]}
                    >
                      <Input
                        type="number"
                        placeholder="e.g. 10"
                        disabled={isViewMode && !isEditing('question', q.id)}
                      />

                    </Form.Item>
                    <Form.Item
                      name={`question_${q.id}_feedback_tip`}
                      label="Feedback Tip"
                    >
                      <Input
                        placeholder="Enter feedback tip"
                        disabled={isViewMode && !isEditing('question', q.id)}
                      />
                    </Form.Item>
                    {/* <MediaUpload
                      fileList={fileList}
                      previewUrl={previewUrl}
                      uploading={uploading}
                      uploadPercent={uploadPercent}
                      handleChange={handleChange}
                      handleClear={handleClear}
                      modifyFileName={modifyFileName}
                      disabled={isViewMode && !isEditing('question', q.id)}
                    /> */}
                  </Col>
                </Row>

                <Row
                  gutter={16}
                  align="middle"
                  justify="space-between"
                  style={{ marginBottom: 16 }}
                >
                  <Col>
                    <span style={{
                      marginRight: 12,
                      fontWeight: 500,
                      color: invalidQuestionIds.includes(q.id) ? "#ff4d4f" : "inherit"
                    }}>
                      Question Type:
                    </span>
                    <Form.Item name={`question_${q.id}_type`} noStyle>
                      <Radio.Group
                        disabled={isViewMode && !isEditing('question', q.id)}
                        onChange={(e) => {
                          const newType = e.target.value;
                          const newQs = [...questions];
                          const q = newQs[qIndex];
                          q.type = newType;

                          // Handle default options count for Creation mode
                          if (!id) {
                            const minOptions = newType === "multiple" ? 3 : 2;
                            while (q.options.length < minOptions) {
                              q.options.push({
                                id: Date.now() + q.options.length,
                                text: `Option ${q.options.length + 1}`,
                                isCorrect: false,
                                order_index: q.options.length + 1
                              });
                            }
                            // Trim if exceeds max for single choice
                            const maxOptions = newType === "multiple" ? 6 : 4;
                            if (q.options.length > maxOptions) {
                              q.options = q.options.slice(0, maxOptions);
                            }
                          }

                          setQuestions(newQs);
                          // Sync with form
                          form.setFieldValue(`question_${q.id}_type`, newType);
                          // Clear validation highlight
                          setInvalidQuestionIds(prev => prev.filter(id => id !== q.id));
                        }}
                        value={q.type || form.getFieldValue(`question_${q.id}_type`)}
                      >
                        <Radio value="single">Single Choice</Radio>
                        <Radio value="multiple">Multiple Choice</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                  <Col>
                    {/* Commented out as per request: Individual answer management is disabled to maintain fixed option state.
                    {isViewMode && !activeEdit && (
                      <Button 
                        type="link" 
                        size="small" 
                        icon={<FormOutlined />} 
                        onClick={() => setActiveEdit({ type: 'answers_block', id: q.id })}
                      >
                        Edit Answers
                      </Button>
                    )}
                    {activeEdit && activeEdit.type === 'answers_block' && activeEdit.id === q.id && (
                      <Button size="small" onClick={async () => {
                        await fetchQuizData();
                        setActiveEdit(null);
                      }}>Cancel</Button>
                    )}
                    */}
                  </Col>
                  {!id && (
                    <Col>
                      <Button
                        type="dashed"
                        size="small"
                        onClick={() => addOption(qIndex)}
                        icon={<PlusOutlined />}
                      >
                        Add Option
                      </Button>
                    </Col>
                  )}
                </Row>

                {/* Inline Options */}
                <Row gutter={[12, 12]} style={{ marginBottom: 16 }}>
                  {q.options.map((opt, optIndex) => {
                    const optId = opt.id || optIndex + 1;
                    const editingThisAnswer = isEditing('answer', optId, q.id);
                    const editingThisQuestion = isEditing('question', q.id);
                    const isEnabled = !isViewMode && (editingThisAnswer || (!activeEdit && !isViewMode));

                    return (
                      <Col key={optId} span={8}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "100%",
                            gap: "4px"
                          }}
                        >
                          <Form.Item
                            name={`question_${q.id}_correct_${optId}`}
                            valuePropName="checked"
                            noStyle
                          >
                            {q.type === "single" ? (
                              <Radio
                                disabled={isViewMode && !editingThisAnswer && !editingThisQuestion}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    // Clear validation highlight
                                    setInvalidQuestionIds(prev => prev.filter(id => id !== q.id));
                                    // Handle Mutual Exclusion for Single Choice
                                    const newQs = [...questions];
                                    q.options.forEach((opt) => {
                                      const otherId = opt.id || opt.answer_id;
                                      if (otherId !== optId) {
                                        // Update State
                                        opt.is_correct = false;
                                        opt.isCorrect = false;
                                        // Update Form UI
                                        form.setFieldValue(`question_${q.id}_correct_${otherId}`, false);
                                      } else {
                                        opt.is_correct = true;
                                        opt.isCorrect = true;
                                      }
                                    });
                                    setQuestions(newQs);
                                  }
                                }}
                              />
                            ) : (
                              <Checkbox
                                disabled={isViewMode && !editingThisAnswer && !editingThisQuestion}
                                onChange={(e) => {
                                  // Clear validation highlight
                                  setInvalidQuestionIds(prev => prev.filter(id => id !== q.id));
                                  const newQs = [...questions];
                                  const targetOpt = newQs[qIndex].options.find(o => (o.id || o.answer_id) === optId);
                                  if (targetOpt) {
                                    targetOpt.is_correct = e.target.checked;
                                    targetOpt.isCorrect = e.target.checked;
                                  }
                                  setQuestions(newQs);
                                }}
                              />
                            )}
                          </Form.Item>
                          <Form.Item
                            name={`question_${q.id}_opt_${optId}`}
                            noStyle
                            rules={[
                              { required: true, message: "Option text is required" },
                            ]}
                          >
                            <Input
                              placeholder={`Option ${optIndex + 1}`}
                              disabled={isViewMode && !editingThisAnswer && !editingThisQuestion}
                              style={{ flex: 1 }}
                            />
                          </Form.Item>
                          <div style={{ display: "flex", gap: "4px" }}>
                            {id && editingThisAnswer ? (
                              <>
                                <Button
                                  type="primary"
                                  size="small"
                                  onClick={() => handleSaveAnswer(q.id, optId)}
                                  className="save-update-btn"
                                >
                                  OK
                                </Button>
                                <Button size="small" onClick={async () => {
                                  // Management mode
                                  await fetchQuizData();
                                  setActiveEdit({ type: 'answers_block', id: q.id });
                                }}>X</Button>
                              </>
                            ) : (
                              (activeEdit?.type === 'answers_block' && activeEdit.id === q.id && !activeEdit.parentId) && (
                                <Button
                                  type="link"
                                  size="small"
                                  icon={<FormOutlined />}
                                  onClick={() => setActiveEdit({ type: 'answer', id: optId, parentId: q.id })}
                                />
                              )
                            )}
                            {!id && (
                              <Button
                                danger
                                size="small"
                                type="text"
                                onClick={() => removeOption(qIndex, optIndex)}
                              >
                                X
                              </Button>
                            )}
                          </div>
                        </div>
                      </Col>
                    );
                  })}
                </Row>
              </Card>
            ))}

            {/* Add Question */}
            {(id || !isViewMode) && (
              <Row style={{ marginTop: "20px" }}>
                <Col span={24}>
                  <Button
                    type="dashed"
                    size="middle"
                    icon={<PlusOutlined />}
                    onClick={addQuestion}
                    block
                    disabled={isViewMode && activeEdit !== null}
                  >
                    Add Question
                  </Button>
                </Col>
              </Row>
            )}

            {/* Submit */}
            <div
              className="group-1-box"
              style={{
                paddingBottom: "0rem",
                paddingLeft: "0px",
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <div>
                <div style={{ display: "inline-block" }}>
                  <Form.Item label=" " colon={false}>
                    <Button
                      type="text"
                      htmlType="button"
                      style={{
                        background: "#D3D3D3",
                      }}
                      onClick={() => navigate(-1)}
                    >
                      <BackwardOutlined />
                      Back
                    </Button>
                  </Form.Item>
                </div>

                {!isViewMode &&(
                  <>
                    <div style={{ display: "inline-block", marginLeft: "16px" }}>
                      <Form.Item label=" " colon={false}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="save-update-btn"
                        >
                          Save
                          <FormOutlined />
                        </Button>
                      </Form.Item>
                    </div>
                    <div style={{ display: "inline-block", marginLeft: "16px" }}>
                      <Form.Item label=" " colon={false}>
                        <Button
                          type="text"
                          htmlType="button"
                          style={{
                            background: "#D3D3D3",
                          }}
                          onClick={() => form.resetFields()}
                        >
                          Reset
                          <RetweetOutlined />
                        </Button>
                      </Form.Item>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Form>
        </Card>
      </div>
    </WrapperComponent>
  );
};
export default CourseQuizAdd;
